export const appUrl = import.meta.env.VITE_REACT_APP_URL || window.location.origin;

/**
 * Build a frontend URL with optional path and query parameters
 *
 * @param path   Optional path (e.g. "/dashboard")
 * @param params Optional query parameters as key-value pairs
 * @returns Full frontend URL as a string
 */
export function getFrontendUrl(path, params= {}) {
  const query = Object.keys(params).length > 0
      ? `?${new URLSearchParams(params).toString()}`
      : "";

  return `${appUrl}${path}${query}`;
}
